import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="duplicate-selection"
export default class extends Controller {
  static values = { group: Number }
  static targets = ["checkbox", "previewButton"]

  updateSelection() {
    const selectedCheckboxes = this.checkboxTargets.filter(cb => cb.checked)
    
    if (selectedCheckboxes.length === 2) {
      const sourceId = selectedCheckboxes[0].value
      const targetId = selectedCheckboxes[1].value
      const baseUrl = this.element.dataset.mergePreviewUrl || "/admin/client_duplicates/merge_preview"
      const url = `${baseUrl}?source_id=${sourceId}&target_id=${targetId}`
      
      this.previewButtonTarget.href = url
      this.previewButtonTarget.style.display = "inline-flex"
    } else {
      this.previewButtonTarget.style.display = "none"
    }

    // Désactiver les autres checkboxes si 2 sont déjà sélectionnées
    if (selectedCheckboxes.length >= 2) {
      this.checkboxTargets.forEach(cb => {
        if (!cb.checked) {
          cb.disabled = true
        }
      })
    } else {
      this.checkboxTargets.forEach(cb => {
        cb.disabled = false
      })
    }
  }
}
